import { FC } from 'react';

import { TrendIndicator } from 'components/atoms/Generic/TrendIndicator';
import { formatNumWithKMBAlt } from 'utils/helperMethods';
import { KpiCardProps } from 'utils/ppaHelpers';

// Skeleton loading state
export const KpiCardSkeleton: FC = () => (
    <div className="flex min-h-[128px] min-w-0 flex-[1_0_0] flex-col items-start gap-4 overflow-hidden rounded-lg border border-borderGrey bg-white px-2 py-4">
        <div className="h-4 w-[87px] shrink-0 rounded bg-[rgba(0,0,0,0.06)]" />
        <div className="flex w-full flex-col gap-[14px]">
            <div className="h-4 w-[95px] shrink-0 rounded bg-[rgba(0,0,0,0.06)]" />
            <div className="h-4 w-full shrink-0 rounded bg-[rgba(0,0,0,0.06)]" />
        </div>
    </div>
);

export const KpiCard: FC<KpiCardProps> = ({
    title,
    value,
    valuePrefix,
    valueSuffix,
    showTrend = true,
    trendValue,
    trendType = 'neutral',
    style,
    className = '',
    rawValue,
}) => {
    const formattedRawValue = (() => {
        if (rawValue === undefined || rawValue === null) return value;
        const num = typeof rawValue === 'number' ? rawValue : parseFloat(String(rawValue));
        if (!isNaN(num)) return formatNumWithKMBAlt(num, 1);
        return rawValue;
    })();
    const isPercentageSuffix = typeof valueSuffix === 'string' && valueSuffix.includes('%');
    const displayValue = [valuePrefix, formattedRawValue, isPercentageSuffix ? valueSuffix : undefined].filter(Boolean).join('');

    return (
        <div
            className={`flex min-h-[116px] min-w-0 flex-[1_0_0] flex-col items-start gap-2.5 rounded-lg border border-borderGrey bg-white p-4 ${className}`}
            style={style}
        >
            <div className="flex flex-col gap-2">
                <p className="m-0 text-base font-medium leading-[22px] text-greyFont opacity-70">
                    {title}
                </p>
                <p className="m-0 text-2xl font-semibold leading-normal tracking-[1px] text-fontColor">
                    {displayValue}
                </p>
            </div>
            {showTrend && trendValue != null && (
                <TrendIndicator
                    value={trendValue}
                    trendType={trendType}
                />
            )}
        </div>
    );
};
